// window.jjj = [
//   {
//     normal: 57334847668605,
//     special: 56024829133181
//   },
//   {
//     normal: 57334847701373,
//     special: 56024829165949
//   },
//   {
//     normal: 57334847734141,
//     special: 56024829198717
//   },
//   {
//     normal: 57334847766909,
//     special: 56024829231485
//   }
// ];


// function getNormalIdBySpecial(specialId) {
//   const match = window.jjj.find(item => item.special === specialId);
//   return match ? match.normal : null; // Return null if not found
// }

document.addEventListener("DOMContentLoaded", function() {
  const variantMap = {
    "57350192136573": "56024829133181",
    "57350192169341": "56024829165949", 
    "57350192202109": "56024829198717", 
    "57350192234877": "56024829231485" 
  };

  let originalVariant = null;

  function getVariantInput() {
    return document.querySelector('form input[name="id"]');
  }

  function getCurrentVariantId() {
    const input = getVariantInput();
    return input ? input.value : null;
  }

  function setVariantId(id) {
    const input = getVariantInput();
    if (input) input.value = id;
  }

  function isSinglePurchaseActive() {
    const oneTimeRadio = document.querySelector('.sls-option[data-type="one_time"]');
    if (!oneTimeRadio) return false;
    const isChecked =
      oneTimeRadio.closest('[role="radio"]')?.getAttribute('aria-checked') === 'true' ||
      oneTimeRadio.checked;
    return isChecked;
  }

  document.body.addEventListener(
    "click",
    function (e) {
      const button = e.target.closest('[type="submit"], button[name="add"]');
      if (!button) return;
      const form = button.closest("form");
      if (!form) return;
      const currentVariant = getCurrentVariantId();
      if (!currentVariant) return;
      if (isSinglePurchaseActive()) {
        if (variantMap[currentVariant]) {
          originalVariant = currentVariant; 
          setVariantId(variantMap[currentVariant]);
        }
      } else {
        if (originalVariant && Object.values(variantMap).includes(currentVariant)) {
          setVariantId(originalVariant);
          originalVariant = null; 
        } else {
        }
      }
    },
    true
  );
  document.body.addEventListener("change", function (e) {
    if (e.target.classList.contains("sls-option")) {
      const currentVariant = getCurrentVariantId();
      if (!currentVariant) return;
      if (!isSinglePurchaseActive() && originalVariant && Object.values(variantMap).includes(currentVariant)) {
        setVariantId(originalVariant);
        originalVariant = null;
      }
    }
  });
});


// async function getCart() {
//     const response = await fetch('/cart.json');
//     return await response.json();
// }



// function cartHasSellingPlan(cart) {
//   if (!cart || !Array.isArray(cart.items)) return false;

//   return cart.items.some(item => {
//     return (
//       item.selling_plan_allocation ||
//       item.selling_plan_id ||
//       item.selling_plan_name
//     );
//   });
// }

// function getFirstVariantId(cart) {
//   if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
//     return null; // no items in cart
//   }

//   return cart.items[0].variant_id;
// }


// async function addVariantToCart(variantId, quantity = 1, properties = {}) {
//   try {
//         await fetch('/cart/clear.js');
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity,
//         properties // optional: for custom line item properties (e.g. engraving text)
//       })
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('✅ Item added to cart:', data);
//     return data;
//   } catch (error) {
//     console.error('❌ Error adding item to cart:', error);
//     return null;
//   }
// }


// async function replaceCartItem(oldVariantId, newVariantId, newQty = 1) {
//   try {
//     const response = await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         updates: {
//           [oldVariantId]: 0,      // Remove old item
//           [newVariantId]: newQty  // Add new item
//         }
//       })
//     });

//     const updatedCart = await response.json();
//     console.log('✅ Cart updated:', updatedCart);
//     return updatedCart;
//   } catch (error) {
//     console.error('❌ Error replacing cart item:', error);
//   }
// }







// async function mainn(){
//     const cart   = await getCart();
//     if( cart.items.length == 0){
//         return ;
//     }

//     const result = cartHasSellingPlan(cart);
//     if( result ){
//         return ;
//     }

//     if( cart.items.length > 1 ){
//         await fetch('/cart/clear.js');
//     }

//     const vid = getFirstVariantId(cart);
//     const normalId = getNormalIdBySpecial(vid);
//     // addVariantToCart(normalId);
//     replaceCartItem(vid, normalId, newQty = 1)
// }






// function getIneeedex() {
//   const options = document.querySelectorAll('.sls-option-container.seal-table');
  
//   options.forEach((option, index) => {
//     if (option.classList.contains('sls-active')) {
//       if (index === 0) {
//         const variantInput = document.querySelector(".shopify-product-form [name='id']");
//         const variantID = Number(variantInput.value); // convert to number (IDs are numeric)
        
//         const normalId = getNormalIdBySpecial(variantID);
//         if (normalId) {
//           variantInput.value = normalId;
//         } else {
//           console.warn(`No matching normal ID found for special ID: ${variantID}`);
//         }
//       }
//     }
//   });
// }

// document.addEventListener("cart:change", (event) => {
//  mainn();
// });



// // Wait for the DOM to be ready
// document.addEventListener('DOMContentLoaded', () => {
//   setInterval(() => {
//     mainn();
//   }, 2000);
// });
